// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__sUU0f","upload":"Small_upload__cfG3q","imageWrap":"Small_imageWrap__369KL","removeBtn":"Small_removeBtn__1MmyG"};